module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4Rtyt"))).then(() => module.bundle.root('hEqeo'));